import React, { useMemo } from 'react'
import { Controller } from 'react-hook-form'
import Select from 'react-select'

const SelectEmailType = ({ control, required = true, isClearable = true, defaultValue }) => {

    const titleOptions = useMemo(() => {
        return [
            { value: 'Approve', label: 'ตรวจเอกสารคำร้อง' },
            { value: 'Appointment', label: 'แจ้งวันนัดทำสัญญา' },
            { value: 'Register', label: 'ลงทะเบียน', isDisabled: true },
            { value: 'Contact', label: 'ข้อมูลติดต่อ', isDisabled: true }
        ]
    }, [])

    const defValue = useMemo(() => {
        if (defaultValue) {
            return titleOptions.find(i => i.value === defaultValue)
        }
        return null
    }, [defaultValue, titleOptions])

    return (
        <Controller
            name="email_type"
            control={control}
            defaultValue={defValue}
            rules={{ required: required }}
            render={({ field }) => <Select options={titleOptions} placeholder="เลือก" {...field} isClearable={isClearable} />}
        />
    )
}

export default SelectEmailType
